module.exports = __webpack_public_path__ + "img/articletop_md.ed019345.png";